import React, { Component } from 'react';
import { Map, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon in Leaflet with Webpack/React
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

import { Button, ButtonGroup } from '@material-ui/core';

import mockData from '../../FrontPage/data.js';

let DefaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});

const selectionIcon = L.icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const createMarkerIcon = (color) => {
    const svgTemplate = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
            <path fill="${color}" d="M16,2C9.38,2,4,7.38,4,14c0,8,12,16,12,16s12-8,12-16C28,7.38,22.62,2,16,2z M16,18c-2.21,0-4-1.79-4-4c0-2.21,1.79-4,4-4 s4,1.79,4,4C20,16.21,18.21,18,16,18z"/>
        </svg>
    `;
    return L.divIcon({
        className: 'custom-marker',
        html: svgTemplate,
        iconSize: [32, 32],
        iconAnchor: [16, 32],
        popupAnchor: [0, -32]
    });
};

const insideIcon = createMarkerIcon('#3f51b5'); // Primary blue
const outsideIcon = createMarkerIcon('#9e9e9e'); // Gray

L.Marker.prototype.options.icon = DefaultIcon;

const gmapScriptId = "gmapscript";

class MapSelectionField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            center: [60.192059, 24.945831], // Helsinki center
            position: null, // No default selection
            address: '',
            radius: 2000, // Default 2km
            autoCompleted: false,
            bounds: null
        };
    }

    componentDidMount() {
        window.handleCallback = this.handleCallback;
        if (!document.getElementById(gmapScriptId)) {
            const gmapScriptEl = document.createElement(`script`);
            gmapScriptEl.id = gmapScriptId;
            gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY
                }&libraries=places&callback=handleCallback`;
            document
                .querySelector(`body`)
                .insertAdjacentElement(`beforeend`, gmapScriptEl);
        } else {
            this.setState({ autoCompleted: true });
        }
    }

    handleMoveEnd = (e) => {
        const map = e.target;
        this.setState({ bounds: map.getBounds().pad(0.1) });
    };

    handleCallback = () => {
        this.setState({
            autoCompleted: true,
        });
    };

    handleMapClick = (e) => {
        const { lat, lng } = e.latlng;
        this.setState({ position: [lat, lng] });
        this.reverseGeocode(lat, lng);
    };

    handleRadiusChange = (radius) => {
        const { position, address } = this.state;
        this.setState({ radius });

        // Update Redux Form and parent logic if we already have a position
        if (position && this.props.onLocationUpdate) {
            this.props.onLocationUpdate({
                location: { lat: position[0], lng: position[1] },
                address: address,
                radius: radius
            });
        }
    }

    reverseGeocode(lat, lng) {
        if (!window.google || !window.google.maps) return;

        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK") {
                if (results[0]) {
                    const address = results[0].formatted_address;
                    this.setState({ address });

                    // Update Redux Form
                    this.props.input.onChange(address);

                    // Update location and address in parent logic
                    if (this.props.onLocationUpdate) {
                        this.props.onLocationUpdate({
                            location: { lat, lng },
                            address: address,
                            radius: this.state.radius
                        });
                    }
                }
            }
        });
    }

    render() {
        const { position, address, radius, center } = this.state;
        const { validity } = this.props;
        const hasError = validity && Boolean(validity.error);

        return (
            <div className="MapSelection-root">
                <div className="MapSelection-container">
                    <Map
                        center={position || center}
                        zoom={13}
                        style={{ height: '100%', width: '100%', borderRadius: '8px' }}
                        onClick={this.handleMapClick}
                        onMoveEnd={this.handleMoveEnd}
                        ref={(ref) => { if (ref && !this.state.bounds) { this.setState({ bounds: ref.leafletElement.getBounds() }); } }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        />
                        {position && (
                            <Marker position={position} icon={selectionIcon}>
                                {address && (
                                    <Popup>
                                        <span>{address}</span>
                                    </Popup>
                                )}
                            </Marker>
                        )}
                        {position && (
                            <Circle
                                center={position}
                                radius={radius}
                                color="blue"
                                fillColor="skyblue"
                                fillOpacity={0.2}
                            />
                        )}

                        {mockData && mockData.announcements && mockData.announcements
                            .filter(announcement => {
                                if (!announcement.location || !this.state.bounds) return false;
                                // Simple bounds check
                                return this.state.bounds.contains([announcement.location.x, announcement.location.y]);
                            })
                            .map((announcement, index) => {
                                const propPosition = [announcement.location.x, announcement.location.y];

                                // Check if property is within circle
                                const distance = position ? L.latLng(position).distanceTo(L.latLng(propPosition)) : 0;
                                const isInside = position ? distance <= radius : true;

                                return (
                                    <Marker
                                        key={index}
                                        position={propPosition}
                                        icon={isInside ? insideIcon : outsideIcon}
                                    >
                                        <Popup>
                                            <div style={{ fontSize: '14px' }}>
                                                <strong>{announcement.company}</strong><br />
                                                {announcement.address}, {announcement.city}<br />
                                                {announcement.size} m² - {announcement.rent} €
                                            </div>
                                        </Popup>
                                    </Marker>
                                );
                            })}
                    </Map>
                </div>

                <div className="MapSelection-footer">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#555' }}>Search Radius:</span>
                        <ButtonGroup color="primary" variant="outlined" size="small">
                            <Button
                                onClick={() => this.handleRadiusChange(500)}
                                variant={radius === 500 ? "contained" : "outlined"}
                            >
                                500m
                            </Button>
                            <Button
                                onClick={() => this.handleRadiusChange(2000)}
                                variant={radius === 2000 ? "contained" : "outlined"}
                            >
                                2km
                            </Button>
                            <Button
                                onClick={() => this.handleRadiusChange(4000)}
                                variant={radius === 4000 ? "contained" : "outlined"}
                            >
                                4km
                            </Button>
                        </ButtonGroup>
                    </div>

                    {address && (
                        <div style={{ fontSize: '14px', color: '#333' }}>
                            <strong>Selected Address:</strong> {address}
                        </div>
                    )}
                </div>

                {hasError && <div className="form-control-feedback" style={{ color: '#d9534f', marginTop: '5px' }}>Invalid input</div>}
            </div>
        );
    }
}

export default MapSelectionField;
